import React from "react";
import ReactDOM from "react-dom/client";
import WidgetRenderer from "../Components/WidgetRenderer/WidgetRenderer";

export default async function init() {
  if (!document.querySelector("[data-react-component]")) return;

  const app = document.createElement("div");
  app.id = "root";
  document.body.appendChild(app);
  const root = ReactDOM.createRoot(app);
  root.render(<WidgetRenderer />);
  const event = new Event("react:app:init");
  window.dispatchEvent(event);
}
